import React from 'react';
import { Tooltip } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { getTagForChangeState } from '../../Common/Tags';
import { formatDateAndTime, formatDateAndTimeFromNow } from '../../../helpers/utils';

/**
 * One submission under the shared column header. The whole row opens it —
 * a submission is a thing you go to rather than something to unfold in
 * place — except the change count, which goes somewhere else.
 */
const SubmissionRow = ({ record }: { record: any }) => {
    const history = useHistory();
    const open = () => history.push(`/submissions/${record.id}`);

    const count = record.num_change_instances ?? 0;

    return (
        <div
            className="sub-row"
            role="button"
            tabIndex={0}
            aria-label={`Open submission ${record.id}`}
            onClick={open}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    open();
                }
            }}
        >
            <div className="sub-cell sub-cell--id" data-label="ID">
                {record.id}
            </div>

            <Tooltip placement="topLeft" title={record.commit_id ? `Commit ${record.commit_id}` : undefined}>
                <div className={`sub-cell sub-cell--commit${record.commit_id ? '' : ' sub-cell--empty'}`} data-label="Commit">
                    {record.commit_id ? record.commit_id.slice(0, 8) : '—'}
                </div>
            </Tooltip>

            <div className="sub-cell" data-label="State">
                {getTagForChangeState(record.change_state)}
            </div>

            {/* the count is a way through to the changes themselves, so the
                click stops here rather than opening the submission behind it */}
            <div
                className="sub-cell sub-cell--count"
                data-label="Changes"
                role="presentation"
                onClick={(event) => event.stopPropagation()}
                onKeyDown={(event) => event.stopPropagation()}
            >
                {count > 0 ? (
                    <Tooltip title={`View the ${count} change instance${count === 1 ? '' : 's'} this raised`}>
                        {/* a raw param rather than a `filter=` value: the list
                            prunes filter values its own schema does not own,
                            and reads this one into its permanent filter */}
                        <Link className="sub-count" to={`/change_instances?submission_id=${record.id}`}>
                            {count}
                        </Link>
                    </Tooltip>
                ) : (
                    <span className="sub-count sub-count--none">0</span>
                )}
            </div>

            <Tooltip title={record.created ? formatDateAndTime(record.created) : undefined}>
                <div className="sub-cell sub-cell--time" data-label="Created">
                    {record.created ? formatDateAndTimeFromNow(record.created) : '—'}
                </div>
            </Tooltip>

            <RightOutlined className="sub-chev" aria-hidden="true" />
        </div>
    );
};

export default SubmissionRow;
